import { ErrorGuardConfig } from '@superbet-group/web.lib.vue-utilities';
import { Store } from 'vuex';

export function createErrorGuardConfig(store: Store<unknown>): ErrorGuardConfig {
    return {
        onAuthFailure: () => store.dispatch('data/authentication/sessionExpired', null, { root: true }),
        onShowGlobalError: (e: Error) => store.dispatch('errors/showError', e, { root: true }),
    };
}
